module.exports = __webpack_public_path__ + "static/guia-de-redacao-f10150fc66ea72b26655df0853a7a062.jpg";